import React from 'react';
import './App.css';
import { getApiUrl } from './apiConfig';

const defaultStaff = [
  {
    position: 'පළාත් කෘෂිකර්ම අධ්‍යක්ෂ',
    name: 'ජී.බී.ඒ.ඩී. රාජපක්ෂ මිය',
    phone: '071-8061972',
    image: '/photos/staff1.jpg'
  },
  {
    position: 'අතිරේක පළාත් කෘෂිකර්ම අධ්‍යක්ෂ',
    name: 'ආර්.පී.එන්.එල්. රාජපක්ෂ මිය',
    phone: '074-1248180',
    image: '/photos/staff2.png'
  },
  {
    position: 'සහකාර කෘෂිකර්ම අධ්‍යක්ෂ(මූලස්ථාන)',
    name: 'ඩබ්.එම්.එස්.එන්. වනසුන්දර මයා',
    phone: '071-8179452',
    image: '/photos/staff3.jpg'
  },
  {
    position: 'ගණකාධිකාරි',
    name: 'අයෝමි විදානගමගේ මිය',
    phone: '071-0361089',
    image: '/photos/staff4.png'
  },
  {
    position: 'පරිපාලන නිලධාරි',
    name: 'ආර්.ආර්. රෝෂාණී මිය',
    phone: '070-5577568',
    image: '/photos/staff5.jpg'
  },
  {
    position: 'විෂයභාර නිලධාරි(මූලස්ථාන)',
    name: 'එම්.පී. මුණසිංහ මයා',
    phone: '077-7930584',
    image: '/photos/staff6.png'
  },
  {
    position: 'පළාත් මාධ්‍ය සම්බන්ධීකාරක',
    name: 'දිල්හානි වික්‍රමසිංහ මිය',
    phone: '077-6063540',
    image: '/photos/staff7.jpg'
  },
  {
    position: 'ප්‍රධාන කලමණාකරණසේවා නිලධාරි',
    name: 'විමලා විජේමැණිකේ මිය',
    phone: '071-7645314',
    image: '/photos/staff8.png'
  },
  {
    position: 'මුදල් සහකාර',
    name: 'පවිත්‍රා සේල්ලහේවා මිය',
    phone: '077-2258582',
    image: '/photos/staff9.png'
  }
];

export default function Staff({ onBackClick }) {
  const handleBack = () => {
    if (onBackClick) {
      onBackClick('about');
    }
  };

  const [staffMembers, setStaffMembers] = React.useState([]);

  React.useEffect(() => {
    const fetchStaff = async () => {
      try {
        const url = getApiUrl(`api_staff.php?t=${Date.now()}`);
        
        const res = await fetch(url);
        if (!res.ok) throw new Error('API Error');
        const data = await res.json();
        
        if (Array.isArray(data) && data.length > 0) {
            setStaffMembers(data);
        } else {
            // Fallback to default
            setStaffMembers(defaultStaff);
        }
      } catch (err) {
        console.error('Fetch staff error:', err);
        setStaffMembers(defaultStaff);
      }
    };
    fetchStaff();
  }, []);

  return (
    <main className="page-content staff-overview" style={{ padding: '28px 16px', paddingBottom: '180px', maxWidth: 1100, margin: '0 auto', position: 'relative' }}>
      <button
        className="back-button"
        onClick={handleBack}
        style={{
          backgroundColor: '#0b6b2f',
          color: 'white',
          border: 'none',
          padding: '8px 16px',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '14px',
          marginBottom: '12px',
          display: 'flex',
          alignItems: 'center',
          gap: '6px'
        }}
        aria-label="Back to About"
      >
        ← ආපසු
      </button>

      <h1 style={{ color: '#0b6b2f', fontSize: 28, marginBottom: 12, textAlign: 'justify' }}>කාර්ය මණ්ඩලය</h1>
      <hr className="footer-sep" />

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
        gap: '12px',
        marginTop: '30px',
        padding: '0 8px'
      }}
        className="staff-grid"
      >
        {staffMembers.map((member, index) => (
          <div key={index} style={{
            backgroundColor: '#f9f9f9',
            border: '1px solid #ddd',
            borderRadius: '12px',
            padding: '24px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
            transition: 'all 0.3s ease',
            textAlign: 'center'
          }}
            className="staff-card"
            onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow = '0 12px 32px rgba(11, 107, 47, 0.25)';
              e.currentTarget.style.transform = 'translateY(-8px)';
              e.currentTarget.style.borderColor = '#0b6b2f';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.borderColor = '#e8e8e8';
            }}>
            <div style={{
              width: '140px',
              height: '160px',
              borderRadius: '8px',
              margin: '0 auto 16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden',
              backgroundColor: 'linear-gradient(135deg, #0b6b2f 0%, #14a75f 100%)',
              border: '3px solid #fff',
              boxShadow: '0 4px 12px rgba(11, 107, 47, 0.2)'
            }}
              className="staff-image"
            >
              {member.image ? (
                <img
                  src={member.image}
                  alt={member.name}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                />
              ) : (
                <span style={{
                  color: 'white',
                  fontSize: '40px',
                  fontWeight: 'bold'
                }}>
                  {member.name.charAt(0)}
                </span>
              )}
            </div>

            <h3 style={{
              color: '#0b6b2f',
              fontSize: '18px',
              fontWeight: '700',
              marginBottom: '8px',
              textAlign: 'justify'
            }}>
              {member.position}
            </h3>

            <p style={{
              color: '#333',
              fontSize: '16px',
              fontWeight: '600',
              marginBottom: '8px',
              textAlign: 'justify'
            }}>
              {member.name}
            </p>

            <p style={{
              color: '#666',
              fontSize: '14px',
              marginBottom: '0',
              textAlign: 'justify',
              lineHeight: '1.6'
            }}>
              📞 {member.phone}
            </p>
          </div>
        ))}
      </div>
    </main>
  );
}
